export const genders = [
  { value: 'male', text: 'Male' },
  { value: 'female', text: 'Female' },
  ];
  